import './index.css';
import * as React from 'react';


export interface Props {
  questionNumber: number;
  onClicked: (questionNumber: number) => void;
  checked?: boolean
}

const AddHintButton: React.SFC<Props> = ({ 
  questionNumber, onClicked, checked=false
}) => {
  let imgNormal = "/assets/images/icons/v2/ico-hint.svg"
  let imgChecked = "/assets/images/icons/v2/ico-check-green.svg"

  return (
    <button
      aria-label="Write or edit hints"
      className="add-hint-button"
      onClick={() => onClicked(questionNumber)}
    >
      <img 
        alt="Add hint" 
        src={!checked ? imgNormal: imgChecked}
        width="20"
        height="20"
      />
    </button>
  )
}

AddHintButton.defaultProps = {
};
AddHintButton.displayName = 'AddHintButton';

export default AddHintButton;
